import { useContext, useEffect } from 'react';
import SaldosContext from '../../context/saldos/SaldosContext';
import { money, num } from '../mercado/utils';
import '../mercado/mis.css';
import { useT } from 'i18n';

const corta = (a) => (a && a.length > 16 ? `${a.slice(0, 8)}…${a.slice(-6)}` : a || '—');

const ModalRetiroUSDT = ({ open, wallet, tipo = '3', monto, setMonto, onSubmit, cargando, onClose }) => {
  const { t } = useT();
  const { saldos } = useContext(SaldosContext);
  const disponible = num(saldos && saldos.DISPONIBLE);

  useEffect(() => {
    if (!open) return undefined;
    const tecla = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [open, onClose]);

  if (!open || !wallet) return null;

  const m = num(monto);
  const excede = m > disponible;
  const listo = m > 0 && !excede;

  return (
    <div className="p7x-overlay" role="dialog" aria-modal="true" aria-label={t('modal.retiroAria')} onClick={onClose}>
      <form className="p7x-modal" onClick={(e) => e.stopPropagation()} onSubmit={onSubmit}>
        <button type="button" className="p7m-cerrar" onClick={onClose} aria-label={t('modal.cerrar')}>×</button>

        <header className="p7x-modal-head">
          <div>
            <h2>{tipo === '3' ? t('modal.retirarUsdt') : t('modal.retirarBanco')}</h2>
            <p>{tipo === '3' ? t('modal.seEnviaWallet') : t('modal.seEnviaCuenta')}</p>
          </div>
        </header>

        {tipo === '3' ? (
          <div className="p7x-dest">
            <div><span>{t('modal.wallet')}</span><strong>{wallet.bank_client}</strong></div>
            <div><span>{t('modal.red')}</span><strong>{wallet.network || '—'}</strong></div>
            <div className="p7x-dest-dir"><span>{t('modal.direccion')}</span><code title={wallet.address_cripto}>{corta(wallet.address_cripto)}</code></div>
          </div>
        ) : (
          <div className="p7x-dest">
            <div><span>{t('modal.banco')}</span><strong>{wallet.bank_name || '—'}</strong></div>
            <div><span>{t('modal.tipoCuenta')}</span><strong>{wallet.bank_type || '—'}</strong></div>
            <div><span>{t('modal.titular')}</span><strong>{wallet.bank_client || '—'}</strong></div>
            <div><span>{t('modal.numCuenta')}</span><code>{wallet.bank_account || '—'}</code></div>
            {wallet.bank_swift ? <div><span>SWIFT</span><code>{wallet.bank_swift}</code></div> : null}
          </div>
        )}

        <label className="p7x-lbl" htmlFor="p7x-monto">{t('modal.cuantoRetirar')}</label>
        <div className="p7x-pct">
          <input className="p7x-in" id="p7x-monto" type="number" min="0.01" step="0.01" inputMode="decimal" value={monto} onChange={(e) => setMonto(e.target.value)} placeholder="0.00" required autoFocus />
          <span>USDT</span>
        </div>
        <div className="p7x-disp">
          <span>{t('modal.disponible')} <strong>{money(disponible)} USDT</strong></span>
          <button type="button" onClick={() => setMonto(String(Math.floor(disponible * 100) / 100))}>{t('modal.retirarTodo')}</button>
        </div>
        {excede && <div className="p7-wallet-error" role="alert">{t('modal.excede')}</div>}

        <div className="p7x-total">
          <span>{tipo === '3' ? t('modal.recibirasWallet') : t('modal.seEnviaATuCuenta')}</span>
          <strong>{money(m)} <small>USDT</small></strong>
        </div>

        <ul className="p7x-notas">
          <li>{t('modal.nota1')}</li>
          {tipo === '3' && <li>{t('modal.nota2')}</li>}
          <li>{t('modal.nota3')}</li>
        </ul>

        <div className="p7-wallet-actions" style={{ marginTop: '.2rem' }}>
          <button type="button" className="p7-btn-ghost" onClick={onClose}>{t('modal.cancelar')}</button>
          <button type="submit" className="p7-btn-gold" disabled={!listo || cargando}>{cargando ? t('modal.enviando') : t('modal.solicitarRetiro')}</button>
        </div>
      </form>
    </div>
  );
};

export default ModalRetiroUSDT;
